module.exports = __webpack_public_path__ + "img/map_suite-locations_founders.62fb9124.jpg";